// store/modules/favorite.module.js
import FavoriteService from "@/services/favorite.service";
import FavoriteListService from "@/services/favoriteList.service";

const state = {
  // master cache of every fav, loaded once on mount
  allFavorites: [],

  // the subset to show in the UI (either “All” or a specific list)
  filteredFavorites: [],
};

const mutations = {
  SET_ALL_FAVORITES(state, favs) {
    state.allFavorites = favs;
  },
  SET_FILTERED_FAVORITES(state, favs) {
    state.filteredFavorites = favs;
  },
  ADD_FAVORITE(state, fav) {
    // always add to the master cache
    state.allFavorites.push(fav);
    // if we’re currently showing “All Favorites” (i.e. filtered === all),
    // immediately append so the UI updates in place
    if (state.filteredFavorites === state.allFavorites) {
      state.filteredFavorites.push(fav);
    }
  },
  UPDATE_FAVORITE(state, updated) {
    // update in master
    const i = state.allFavorites.findIndex((f) => f.id === updated.id);
    if (i !== -1) state.allFavorites.splice(i, 1, updated);
    // update in filtered
    const j = state.filteredFavorites.findIndex((f) => f.id === updated.id);
    if (j !== -1) state.filteredFavorites.splice(j, 1, updated);
  },
  REMOVE_FAVORITE(state, favId) {
    state.allFavorites = state.allFavorites.filter((f) => f.id !== favId);
    state.filteredFavorites = state.filteredFavorites.filter(
      (f) => f.id !== favId
    );
  },

  REMOVE_FAVORITE_BY_LISTING_ID(state, listingId) {
  state.allFavorites = state.allFavorites.filter(f => f.listing.id !== listingId);
  state.filteredFavorites = state.filteredFavorites.filter(f => f.listing.id !== listingId);
}

};

const actions = {
  /** 1️⃣ Load every favorite once into `allFavorites` */
  async fetchAllFavorites({ commit }) {
    const res = await FavoriteService.getFavorites();
    console.log("We are fetching all favorites", res.data.data);
    commit("SET_ALL_FAVORITES", res.data.data);
  },

  /**
   * 2️⃣ Load `filteredFavorites`:
   *    • if listId=null → show the full cache
   *    • otherwise → fetch that list’s items from the backend
   */
  async fetchFavorites({ commit, state }, listId = null) {
    let favs;
    if (listId === null) {
      favs = state.allFavorites;
    } else {
      const res = await FavoriteListService.getFavoriteList(listId);
      favs = res.data.data.favorites;
    }
    commit("SET_FILTERED_FAVORITES", favs);
  },

  /** Add a brand-new favorite (push to backend & update both caches) */
  async addFavorite({ commit }, payload) {
    const res = await FavoriteService.addFavorite(payload);
    commit("ADD_FAVORITE", res.data.data);
  },

  /** Update an existing favorite’s list-assignment */
  async updateFavorite({ commit }, { id, payload }) {
    const res = await FavoriteService.updateFavorite(id, payload);
    commit("UPDATE_FAVORITE", res.data.data);
  },

  /** Remove a favorite entirely */
  // async removeFavorite({ commit }, favId) {
  //   await FavoriteService.removeFavorite(favId);
  //   commit("REMOVE_FAVORITE", favId);
  // },

  async removeFavorite({ commit }, listingId) {
    await FavoriteService.removeFavorite(listingId);
    // Remove it from local state by listingId
    commit("REMOVE_FAVORITE_BY_LISTING_ID", listingId);
  },
};

const getters = {
  // full master cache
  allFavorites: (state) => state.allFavorites,

  // current view
  favorites: (state) => state.filteredFavorites,

  // helper to quickly check if a listing is saved
  isFavorited: (state) => (listingId) =>
    state.allFavorites.some((f) => f.listing.id === listingId),

  // getFavoriteRecordId: (state) => (listingId) => {
  //   const favorite = state.favorites.find(fav => fav.listing_id === listingId);
  //   return favorite ? favorite.id : null;
  // },
  getFavoriteRecordId: (state) => (listingId) => {
    const favorite = state.allFavorites.find(
      (fav) => fav.listing.id === listingId
    );
    return favorite ? favorite.id : null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
